var map = {
	"./testimonial-01.jpg": "e352",
	"./testimonial-02.jpg": "32f1",
	"./testimonial-03.jpg": "eb91",
	"./testimonial-dark-01 - Copy - Copy.jpg": "3d0a",
	"./testimonial-dark-01.jpg": "43b2",
	"./testimonial-dark-02.jpg": "d41f",
	"./testimonial-dark-03.jpg": "9e69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05ba";